export const REDUCER_NAME = 'file-upload'

export const MAX_SCAN_FILE_SIZE = 90 * 1024 * 1024




// WEBPACK FOOTER //
// ./src/modules/customer/state/file-upload/const.js